import { cn } from '@/src/helpers';
import { TradingSectionBody, TradingSectionHeader, TradingSectionTitle } from './atoms';
import { tradingSectionClasses } from './trading-section.constants';

type TradingSectionProps = React.HTMLAttributes<HTMLDivElement>;

type TradingSectionComponent = React.FC<TradingSectionProps> & {
  Body: typeof TradingSectionBody;
  Header: typeof TradingSectionHeader;
  Title: typeof TradingSectionTitle;
};

export const TradingSection: TradingSectionComponent = ({ children, className, ...rest }) => (
  <main
    {...rest}
    className={cn(
      tradingSectionClasses.root,
      'flex flex-1 flex-col overflow-hidden rounded-lg border border-border bg-card w-full',
      className
    )}
  >
    {children}
  </main>
);

TradingSection.Body = TradingSectionBody;
TradingSection.Header = TradingSectionHeader;
TradingSection.Title = TradingSectionTitle;
